class AutocompleteFieldConfig {
  id = null;
  name = null;
  type = null;
  placeholder = null;
}

export default AutocompleteFieldConfig;
